import {useMutation} from '@tanstack/react-query';
import axios from 'axios';
import {toast} from '@ui/toast/toast';
import {apiClient} from '../../http/query-client';

export interface ForgotPhoneNumberVerifyEmailOtpPayload {
  email: string;
  code: string;
}

export function useForgotPhoneNumberVerifyEmailOtp() {
  return useMutation({
    mutationFn: (payload: ForgotPhoneNumberVerifyEmailOtpPayload) =>
      verifyEmailOtp(payload),
    onError: err => {
      const msg = axios.isAxiosError(err) && err.response?.data?.error;
      toast.danger(msg || 'There was an issue. Please try again.');
    },
  });
}

function verifyEmailOtp(payload: ForgotPhoneNumberVerifyEmailOtpPayload) {
  return apiClient
    .post('forgot-phone-number/verify-email-otp', payload)
    .then(response => response.data);
}
